import styled from 'styled-components';
export const Container = styled.div`
  background-color:#e8e8e8;
  width: 100%;
  height: 100%;
  display:flex;
  flex-direction: row;
  border-radius: 8px;
  input{
    width: 100%;
    margin-right:10px;
    border: none;
    outline:none;
    background-color: transparent;
  }
`
export const Icon = styled.label`
  width: 2rem;
  height: 100%;
  color:#495057;
  display: flex;
  align-items: center;
  padding: 0.5rem;
  background: transparent;
  font-size: 1.5rem;
  font-weight: 500;
  margin-left: 0.3rem;
`
export const Button = styled.button`
  outline: none;
  border: none;
  height: 100%;
  width: 5rem;
  font-size: 0.8rem;
  border-radius: 0px 4px 4px 0px;
  background: #1D86FF;
  color: #ffffff;
  cursor: pointer;

  &:hover{
    box-shadow: 0 1px 2px 0 rgba(60,64,67,0.302), 0 1px 3px 1px rgba(60,64,67,0.149);
  }
`